import { useEffect } from "react";
import Lenis from "lenis";
import { SiteContentProvider } from "@/context/SiteContentContext";

import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import WhyUs from "@/components/site/WhyUs";
import BeforeAfter from "@/components/site/BeforeAfter";
import Gallery from "@/components/site/Gallery";
import BookingCTA from "@/components/site/BookingCTA";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Site() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, touchMultiplier: 1.6 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <SiteContentProvider>
      <div className="App bg-ink text-cream font-sans antialiased overflow-x-hidden">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <BeforeAfter />
          <Gallery />
          <WhyUs />
          <BookingCTA />
          <Contact />
        </main>
        <Footer />
      </div>
    </SiteContentProvider>
  );
}
